import React from 'react';
import connectToStores from 'alt-utils/lib/connectToStores';
import AuthStore from 'stores/AuthStore';
import FolderStore from 'stores/inbox/FolderStore';
import './ViewInboxItem.styl';
import TrendHistoryActions from 'actions/inbox/TrendHistoryActions';
import TrendHistoryStore from 'stores/inbox/TrendHistoryStore';
import TrendDetail from 'components/inbox/page-content/TrendDetail';
import TriggerRuleActions from 'actions/triggers/TriggerRuleActions';
import TriggerRuleStore from 'stores/triggers/TriggerRuleStore';
import TrendCallHistory from 'components/inbox/page-content/TrendCallHistory';
import MailStore from 'stores/inbox/MailStore';
import MailActions from 'actions/inbox/MailActions';
import ViewItemToolbar from 'components/inbox/mail-toolbar/ViewItemToolbar';
import {getQuery, getQueryParam} from 'utils/getQueryParam';

@connectToStores
export default class ViewTrendCalls extends React.PureComponent {
  static getStores() {
    return [AuthStore, FolderStore, TrendHistoryStore, TriggerRuleStore, MailStore];
  }

  static getPropsFromStores(props) {
    const {location} = props;
    const triggerRuleState = TriggerRuleStore.getState();
    const rule = triggerRuleState.rules.get(props.params.ruleId);

    const itemId = getQueryParam(location, 'itemId');
    const mail = itemId ? MailStore.getState().mail.get(parseInt(itemId)) : undefined;

    return {
      trendHistory: TrendHistoryStore.getState().trendHistory,
      trendHistoryLoading: TrendHistoryStore.getState().loading,
      folders: FolderStore.getState().folders,
      rule: rule,
      item: mail,
    };
  }

  componentDidMount() {
    const {params, location} = this.props;
    const {ruleId} = params;
    const {itemId, start, end, reference} = getQuery(location);

    if (itemId) {
      // if itemId, we navigated here from a folder/inbox.
      TrendHistoryActions.fetchTrendHistory.defer(ruleId, itemId, 0, 5);
    } else {
      // if no itemId, we came here directly from an email
      TrendHistoryActions.fetchTrendHistoryPeriod.defer(
        ruleId,
        start,
        end,
        reference,
        // page and pageSize are not currently being used
        0,
        5
      );
    }
    TriggerRuleActions.fetchTriggerRule.defer(ruleId);
    itemId && MailActions.fetchMailItem.defer(itemId);

    document.documentElement.scrollTop = 0;
  }

  render() {
    const {trendHistory, trendHistoryLoading, rule, item, folders, location} = this.props;

    if (!trendHistory && !rule) return null;

    return (
      <div>
        {item && (
          <ViewItemToolbar
            inboxItem={item}
            folders={folders}
            showMoveToTrash
            showMoveToFolder
            showPin
          />
        )}
        <TrendDetail rule={rule} location={location} />
        <TrendCallHistory
          trendHistory={trendHistory}
          trendHistoryLoading={trendHistoryLoading}
          item={item}
        />
      </div>
    );
  }
}
